export const GET_CUESTIONARIO = "GET_CUESTIONARIO";
export const LOADING_CUESTIONARIO = "LOADING_CUESTIONARIO";
export const CUESTIONARIO_FAIL = "CUESTIONARIO_FAIL";

// Para guardar cuestionario
export const SAVE_LOADING_CUESTIONARIO = "SAVE_LOADING_CUESTIONARIO";
export const FORM_FAIL = "FORM_FAIL";
